import { ProtocolSettings } from "./ProtocolSettings";
import { CommandLineSettings } from "./CommandLineSettings";
import { ProtocolSettingsTypes } from "./ProtocolSettingsTypes";

export class SshSettings extends CommandLineSettings {

	constructor() {
		super();
		this.Port = this.DefaultPort;
	}

	public get SettingsType(): string {
		return ProtocolSettingsTypes.Ssh;
	}

	public get DefaultPort(): number {
		return 22;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof SshSettings))
			return;
		let other = (obj as SshSettings);

		super.Copy(obj);
	}

	public Clone(): ProtocolSettings {
		let clone = new SshSettings();
		clone.Copy(this);
		return clone;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof SshSettings))
			return false;
		let other: SshSettings = (obj as SshSettings);

		return true;
	}

	public Write(obj: any, context: any): void {
		obj.ssh = {};
		obj = obj.ssh;

		super.Write(obj, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ssh)
			throw new Error();
		obj = obj.ssh;

		super.Read(obj, context);
	}

}
